import { Card, CardContent, Typography, Box, useTheme } from "@mui/material";
import React from "react";

export interface OptionCardProps {
  title: string;
  iconSrc?: string;
  iconAlt?: string;
  onClick: () => void;
  disabled?: boolean;
}

const OptionCard: React.FC<OptionCardProps> = ({
  title,
  iconSrc,
  iconAlt = "",
  onClick,
  disabled = false
}) => {
  const theme = useTheme();
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 179,
        minWidth: 140,
        height: 126,
        borderRadius: "16px",
        border: `1px solid ${theme.palette.customColors.inputBorder}`,
        boxShadow: theme.palette.customColors.shadowLow,
        backgroundColor: theme.palette.background.paper,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        transition: "all 0.2s ease-in-out",
        "&:hover": disabled
          ? {}
          : {
              transform: "translateY(-2px)",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.08)"
            },
        "&:active": disabled
          ? {}
          : {
              transform: "translateY(0px)"
            }
      }}
      onClick={disabled ? undefined : onClick}
    >
      <CardContent
        sx={{
          p: 2,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 2
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: theme.typography.fontFamily,
            fontWeight: 325,
            fontSize: "16px",
            lineHeight: "20px",
            letterSpacing: "0%",
            color: theme.palette.customColors.textSecondary
          }}
        >
          {title}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
          {iconSrc && (
            <img
              src={iconSrc}
              alt={iconAlt}
              style={{ width: 24, height: 24 }}
            />
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default OptionCard;
